import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";

export default function useUpdateDomLang(lang = "en") {
  const location = useLocation();

  const urlParams = useMemo(() => {
    return new URLSearchParams(location.search);
  }, [location.search]);

  useEffect(() => {
    if (urlParams.get("lang")) {
      document.documentElement.lang = getLanguageCode(urlParams.get("lang"));
    } else {
      document.documentElement.lang = getLangCode(navigator.language);
    }
  });
}

function getLangCode(code) {
  const languageCode = code.split("-")[0];

  return languageCode ?? "en";
}

  function getLanguageCode(lang) {
    const languageMap = {
      arabic: "ar",
      german: "de",
      ukrainian: "uk",
      vietnamese: "vi",
      portuguese: "pt",
      greek: "el",
      korean: "ko",
      bulgarian: "bg",
      polish: "pl",
      romanian: "ro",
      yoruba: "yo",
      serbian: "sr",
      slovak: "sk",
      spanish: "es",
      russian: "ru",
      lithuanian: "lt",
    };
  
    return languageMap[lang] || "en";

}
